<section>
    <form [formGroup]="filterForm" class="container-filter">
        <mat-form-field>
            <mat-label>Busqueda</mat-label>
            <input formControlName="search" matInput>
        </mat-form-field>
        
        <mat-form-field>
            <mat-label>Elige rango de días</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate (dateInput)="changeDateInput($event)" formControlName="start" placeholder="Inicio">
                <input matEndDate (dateInput)="changeDateInput($event)" formControlName="end" placeholder="Termino">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancelar</button>
                    <button mat-raised-button (click)="applyDateRangePicker()" color="primary" matDatepickerApply>Aplicar</button>
                  </mat-datepicker-actions>                        
            </mat-date-range-picker>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Filtro</mat-label>
            <mat-select formControlName="dateRange" (selectionChange)="changeFilterSelect($event)">
                <mat-option *ngFor="let filter of selectFilters"
                [ngClass]="{'hidden': filter.value === 0}"
                [value]="filter.value">
                {{filter.text}}
                </mat-option>
            </mat-select>    
        </mat-form-field>

    </form>
</section>